// extracted by mini-css-extract-plugin
export var label = "_f4-2";
export var slideContainer = "_f4-0";
export var slider = "_f4-1";